import { useEffect, useState } from "react";
import { Download } from "lucide-react";

export default function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setVisible(true); };
    const onInstalled = () => { setVisible(false); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (!visible) return null;

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch (e) { /* ignore */ }
    setDeferred(null);
    setVisible(false);
  };

  return (
    <button
      onClick={install}
      data-testid="pwa-install-button"
      aria-label="Uygulamayı Yükle"
      className="flex items-center gap-1.5 px-3 py-2 text-sm font-medium text-white bg-[#B8933F] hover:bg-[#9C7A33] rounded-sm transition-colors duration-150"
    >
      <Download className="w-4 h-4" /> <span className="hidden sm:inline">Uygulamayı Yükle</span>
    </button>
  );
}
